import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Select from 'react-select';
import _actions from '../../actions';
import constants from '../../constants';
import VersionBox from '../../components/common/VersionBox';
import EditInput from '../../components/forms/EditInput';
import GeneralSection from '../../components/common/GeneralSection';
import HorizontalFormContainer from '../../components/forms/HorizontalFormContainer';
import OnOffSwitch from '../../components/forms/OnOffSwitch';
import ManagedInput from '../../components/forms/ManagedInput';
import PreviewGivingModule from '../../components/preview/PreviewGiving';
import i18n from '../../i18n';
import ValidatedControl from '../../components/forms/ValidatedControl';
import UserSelectedIconSelect from '../../components/pages/UserSelectedIconSelect';

const FMSCategoryName = 'General Donation';

let defaultTabs = [];

export class GivingModule extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoaded: false,
            menuItem: {},
            module: {},
            showPreview: true,
        };

        this.updateMenuItemFromEvent = this.updateMenuItemFromEvent.bind(this);
        this.updateModuleTabsFromEvent = this.updateModuleTabsFromEvent.bind(this);
        this.updateModuleFieldWithValue = this.updateModuleFieldWithValue.bind(this);
        this.updateModuleFromEvent = this.updateModuleFromEvent.bind(this);
        this.updateFormsSourceFromSelect = this.updateFormsSourceFromSelect.bind(this);
    }

    componentDidMount() {
        this.props.actions.getProjectVersion(this.props.match.params.projectId);
        this.props.actions.getProjectVersionMenuItems(this.props.match.params.projectId);
        this.props.actions.getProjectVersionModules(this.props.match.params.projectId);
        this.props.actions.getModuleByTypeAndForms(this.props.match.params.projectId, constants.ModuleType.find((mt) => { return mt.Name === 'Giving'; }).Id);
        defaultTabs = [
            {
                name: 'tab1Name',
                value: i18n.t('modules.giving.give'),
            },
            {
                name: 'tab2Name',
                value: i18n.t('modules.giving.history'),
            },
            {
                name: 'tab3Name',
                value: i18n.t('modules.giving.special'),
            },
            {
                name: 'tab4Name',
                value: i18n.t('modules.giving.scheduled'),
            }];
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.modules.select.id
            && this.props.modules.select.moduleType === constants.ModuleType.find((m) => { return m.Name === 'Giving'; }).Id
            && this.props.modules.select.enabled) {
            if (this.props.alerts.data.length > 0 && this.props.alerts.data.find((m) => { return m.id === 'module-disabled'; })) {
                this.props.actions.clearAlert('module-disabled');
            }
        }
        if (!prevState.isLoaded) {
            if (this.props.modules.select.id
                && this.props.modules.select.moduleType === constants.ModuleType.find((m) => { return m.Name === 'Giving'; }).Id
                && !this.props.modules.select.enabled) {
                this.props.actions.addAlert({
                    message: i18n.t('modules.giving.error1'),
                    linkText: i18n.t('enableHere'),
                    link: `/projects/${this.props.match.params.projectId}/modules/enable-modules`,
                    view: '/modules/giving',
                    type: 'warning',
                    id: 'module-disabled',
                });
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({ isLoaded: true });
            }
        }
        if (!this.props.forms.inProgress
            && !this.props.modules.inProgress
            && !this.state.formsLoaded
            && (this.props.forms.filtered.length === 0)) {
            this.props.actions.addAlert({
                message: `${i18n.t('forms.error')} "${FMSCategoryName}".`,
                view: '/modules/giving',
                type: 'error',
                id: 'forms-missing-giving',
            });
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ formsLoaded: true });
        }

        if ((!this.props.menuItems.inProgress
            && prevProps.menuItems.inProgress)
            || (!this.props.modules.inProgress
                && prevProps.modules.inProgress)) {
            let menuItem = this.props.menuItems.data.length !== 0 &&
                typeof this.props.modules.select.moduleType === 'number'
                ? this.props.menuItems.data.find((mi) => mi.type === 1 && parseInt(mi.subType, 10) === this.props.modules.select.moduleType)
                : '';
            menuItem = menuItem || {};
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ menuItem });
        }
        if (!this.props.modules.inProgress && prevProps.modules.inProgress) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ module: this.props.modules.select });
        }
    }

    mapFormsToOptions = (forms) => {
        if (forms) {
            return forms.map((form) => {
                return {
                    value: form.id,
                    label: form.name,
                };
            });
        }
        return [];
    }

    updateFormsSourceFromSelect(val) {
        this.setState((prevState) => {
            return {
                module: {
                    ...prevState.module,
                    formId: val.value,
                },
            };
        });
        this.updateModuleFieldWithValue('formId', val.value);
    }

    updateMenuItemFromEvent(evt) {
        const fieldName = evt.target.name;
        const changedValue = evt.target.value.trim().length > 0 ? evt.target.value.trim() : i18n.t('modules.giving.title');
        if (changedValue !== '') {
            this.setState((prevState) => {
                return {
                    menuItem: {
                        ...prevState.menuItem,
                        title: changedValue,
                    },
                };
            });
            this.props.actions.updateMenuItemParameter(
                this.props.match.params.projectId,
                this.state.module.moduleType,
                1,
                fieldName,
                changedValue,
            );
        }
    }

    updateModuleTabsFromEvent(evt) {
        const fieldName = evt.target.name;
        const changedValue = evt.target.value.trim();
        if (changedValue !== '') {
            const newState = this.state.module;
            newState[fieldName] = changedValue;
            this.setState({ module: { ...newState } });
            this.updateModuleFieldWithValue(fieldName, changedValue);
        } else {
            const fieldData = defaultTabs.find((tab) => { return tab.name === fieldName; });
            const newState = this.state.module;
            newState[fieldName] = fieldData.value;
            this.setState({ module: { ...newState } });
            this.updateModuleFieldWithValue(fieldName, fieldData.value);
        }
    }

    updateModuleFromEvent(evt) {
        const fieldName = evt.target.name;
        const changedValue = evt.target.checked;
        this.setState((prevState) => {
            return {
                module: {
                    ...prevState.module,
                    [fieldName]: changedValue,
                },
            };
        });
        this.updateModuleFieldWithValue(fieldName, changedValue);
    }

    updateModuleFieldWithValue(field, val) {
        this.props.actions.updateModuleParameter(
            this.props.match.params.projectId,
            this.state.module.moduleType,
            field,
            val,
        );
    }

    render() {
        let previewGiving = null;
        const formOptions = this.mapFormsToOptions(this.props.forms.filtered);
        let activeCheckin = this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'Check-In'; }).Id; });
        activeCheckin = activeCheckin.filter((module) => { return module.enabled === true; });
        const selectedForm = this.props.forms.filtered.filter((form) => { return form.id === this.state.module.formId; })[0];
        const selectedFormNotSubmittable = selectedForm ? selectedForm.isSubmittable !== true : false;
        let partnersOption = '';
        if (this.state.module.showSpecialDonationsTab) {
            partnersOption = (
                <div className="module-display-setting history-tab">
                    <HorizontalFormContainer
                        inputClass="module-display-setting__setting"
                        title={i18n.t('modules.giving.section3.label3')}
                    >
                        <div id="tab3name" className="form-control">
                            <ManagedInput
                                type="text"
                                placeholder={i18n.t('modules.giving.special')}
                                name="tab3Name"
                                value={this.state.module.tab3Name ? this.state.module.tab3Name : i18n.t('modules.giving.special')}
                                maxLength={12}
                                onBlur={this.updateModuleTabsFromEvent}
                                onReturnDown={this.updateModuleTabsFromEvent}
                                autoFocus={false}
                                dataqa="giving-tab3name"
                            />
                        </div>
                    </HorizontalFormContainer>
                </div>
            );
        }
        let scheduledOption = '';
        if (this.state.module.showScheduledGiftsTab) {
            scheduledOption = (
                <div className="module-display-setting history-tab">
                    <HorizontalFormContainer
                        inputClass="module-display-setting__setting"
                        title={i18n.t('modules.giving.section3.label4')}
                    >
                        <div id="tab4name" className="form-control">
                            <ManagedInput
                                type="text"
                                placeholder={i18n.t('modules.giving.scheduled')}
                                name="tab4Name"
                                value={this.state.module.tab4Name ? this.state.module.tab4Name : i18n.t('modules.giving.scheduled')}
                                maxLength={12}
                                onBlur={this.updateModuleTabsFromEvent}
                                onReturnDown={this.updateModuleTabsFromEvent}
                                autoFocus={false}
                                dataqa="giving-tab4name"
                            />
                        </div>
                    </HorizontalFormContainer>
                </div>
            );
        }
        let bodyForm = '';
        if (this.state.module.enabled) {
            previewGiving = (
                <PreviewGivingModule
                    module={this.state.module}
                    menuItem={this.state.menuItem}
                    baseColorTheme={this.props.versions.select.baseColorTheme}
                    actionColor={this.props.versions?.select?.actionColor?.substring(1)}
                    accentColor={this.props.versions?.select?.accentColor?.substring(1)}
                    secondaryText={this.props.versions?.select?.secondaryText?.substring(1)}
                    primaryText={this.props.versions?.select?.primaryText?.substring(1)}
                    menuStyle={this.props.versions.select.menuStyle}
                    menuItems={this.props.menuItems.data}
                    checkin={
                        this.props.flags.results?.chMSIntegration
                        && this.props.flags.results?.chMSCheckIn
                        && activeCheckin.length > 0
                    }
                />
            );
            bodyForm = (
                <div id="giving-module-page" data-qa="giving-module-page" className="form-wrapper">
                    <h1
                        data-qa="giving-module-header"
                        id="giving-module-header"
                    >
                        {i18n.t('modules.giving.title')}
                    </h1>
                    <p
                        data-qa="giving-module-subhead"
                        id="giving-module-subhead"
                        className="lead"
                    >
                        {i18n.t('modules.giving.subtitle')}
                    </p>
                    <GeneralSection
                        name={i18n.t('modules.giving.section1')}
                        sectionClass="edit-module-name module-display-settings-list"
                    >
                        <div
                            id="module-display-setting"
                            className="module-display-setting"
                        >
                            <EditInput
                                containerId="edit-module-name"
                                containerClass="edit-module-name-wrap"
                                name="title"
                                labelText={i18n.t('name')}
                                value={
                                    this.state.menuItem?.title || i18n.t('modules.giving.title')
                                }
                                charLimit={12}
                                onBlur={this.updateMenuItemFromEvent}
                                onReturnDown={this.updateMenuItemFromEvent}
                                actionClass="edit-module-name-action"
                                placeholder={i18n.t('modules.giving.title')}
                                dataqa="giving-module-name"
                                menuTitle
                            />
                            {this.props.flags.results?.userSelectedIcons
                                && (
                                    <HorizontalFormContainer
                                        inputClass="module-display-setting__setting"
                                        title="Menu Icon"
                                    >
                                        <UserSelectedIconSelect
                                            id={this.state.menuItem.subType}
                                            type={this.state.menuItem.type}
                                            autoUpdate
                                        />
                                    </HorizontalFormContainer>
                                )}
                        </div>
                    </GeneralSection>

                    <GeneralSection
                        sectionClass="module-display-settings-list"
                        dataqa="module-display-settings"
                    >
                        <div
                            data-qa="module-display-setting"
                            id="module-display-setting"
                            className="module-display-setting"
                        >

                            <HorizontalFormContainer
                                inputClass="module-display-setting__setting"
                                title={i18n.t('modules.giving.section2.label1')}
                            >
                                <ValidatedControl
                                    containerClass="fmsSelector"
                                    hasError={false}
                                    errorMessage
                                    hasWarning={selectedFormNotSubmittable}
                                    warningMessage="Selected form is not active for submissions"
                                    hasSuccess={false}
                                    successMessage=""
                                >
                                    <Select
                                        id="formOptions"
                                        options={formOptions}
                                        className="form-selector"
                                        classNamePrefix="form-selector"
                                        value={formOptions.length > 0 ? formOptions.find((f) => { return f.value === this.state.module.formId; }) : ''}
                                        onChange={this.updateFormsSourceFromSelect}
                                        clearable={false}
                                        disabled={formOptions.length === 0}
                                        searchable={false}
                                    />
                                </ValidatedControl>
                            </HorizontalFormContainer>

                            <HorizontalFormContainer
                                inputClass="module-display-setting__setting"
                                title={i18n.t('modules.giving.section2.label2')}
                            >
                                <OnOffSwitch
                                    id="show-extra-tab"
                                    buttonClass="toggle checkbox md-checkbox large-switch"
                                    isToggleOn={this.state.module.showSpecialDonationsTab}
                                    name="showSpecialDonationsTab"
                                    onChange={this.updateModuleFromEvent}
                                    dataQA="show-special-donations"
                                />

                            </HorizontalFormContainer>

                            <HorizontalFormContainer
                                inputClass="module-display-setting__setting"
                                title={i18n.t('modules.giving.section2.label3')}
                            >

                                <OnOffSwitch
                                    id="show-scheduled-gifts-tab"
                                    buttonClass="toggle checkbox md-checkbox large-switch"
                                    isToggleOn={this.state.module.showScheduledGiftsTab}
                                    name="showScheduledGiftsTab"
                                    onChange={this.updateModuleFromEvent}
                                    dataQA="show-scheduled-gifts"
                                />

                            </HorizontalFormContainer>

                        </div>
                        <div
                            id="module-display-setting__giving-tab"
                            className="module-display-setting"
                        >
                            <HorizontalFormContainer
                                inputClass="module-display-setting__setting giving-tab"
                                title={i18n.t('modules.giving.section3.label1')}
                            >
                                <div id="tab1name" className="form-control">
                                    <ManagedInput
                                        type="text"
                                        placeholder={i18n.t('modules.giving.give')}
                                        name="tab1Name"
                                        value={this.state.module.tab1Name}
                                        maxLength={12}
                                        onBlur={this.updateModuleTabsFromEvent}
                                        onReturnDown={this.updateModuleTabsFromEvent}
                                        autoFocus={false}
                                        dataqa="giving-tab1Name"
                                    />
                                </div>
                            </HorizontalFormContainer>
                        </div>

                        <div
                            id="module-display-setting__history-tab"
                            className="module-display-setting history-tab"
                        >
                            <HorizontalFormContainer
                                inputClass="module-display-setting__setting"
                                title={i18n.t('modules.giving.section3.label2')}
                            >
                                <div id="tab2name" className="form-control">
                                    <ManagedInput
                                        type="text"
                                        placeholder={i18n.t('modules.giving.history')}
                                        name="tab2Name"
                                        value={this.state.module.tab2Name}
                                        maxLength={12}
                                        onBlur={this.updateModuleTabsFromEvent}
                                        onReturnDown={this.updateModuleTabsFromEvent}
                                        autoFocus={false}
                                        dataqa="giving-tab2name"
                                    />
                                </div>
                            </HorizontalFormContainer>
                        </div>
                        {partnersOption}
                        {scheduledOption}
                    </GeneralSection>
                </div>
            );
        }

        return (
            <VersionBox
                name={this.props.versions.select.name}
                versionNumber={this.props.versions.select.version}
                saving={this.props.modules.inProgress}
                justSaved={this.props.modules.justSaved}
                menuSection="Modules"
                menuItem="GivingModule"
                previewCssClass="modules_giving"
                previewChild={previewGiving}
                showPreview={this.state.showPreview}
                x
            >
                <div className="content-inside">
                    {bodyForm}
                </div>
            </VersionBox>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(GivingModule);
